import { useAuth } from "@/hooks/useAuth"
import type { LoginCouncilDTO } from "@/gen/api"

export default function useCurrentUser() {
  const { user } = useAuth()
  return {
    councils: user?.councils || [],
    hasRole: (role: string) => {
      return (
        user?.role === role ||
        (user?.councils?.some((c: LoginCouncilDTO) => c.role === role) ?? false)
      )
    },
  }
}
